import React from "react";
import { useStaticQuery, graphql } from "gatsby"
import {Link}  from "gatsby"

const GetCTA = (props) => {
    const data = useStaticQuery(graphql`
    query  {  
      glstrapi {
        allMenus(sort:"Sorting:asc") {
          id
          Label
          Primary_URL
          Secondary_URL
          Main_Parent {
            id
            Label
            Primary_URL
            Disable_Parent_URL
          }
          Sub_Parent {
            id
            Label
            Primary_URL
          }
        }
      }
    }
  `)
  var menu_data = data.glstrapi.allMenus;
  return (
    <>
        {menu_data.map((menuitem) => {
        return<>
            {menuitem.Main_Parent === null && menuitem.Sub_Parent === null && props.link === menuitem.Primary_URL &&
            <Link to={`/${menuitem.Primary_URL}/`} className={props.class}>
                {props.Label}
            </Link>
            }
            {menuitem.Main_Parent != null && menuitem.Sub_Parent === null && props.link === menuitem.Primary_URL && menuitem.Main_Parent.Disable_Parent_URL == true &&
            <Link to={`/${menuitem.Primary_URL}/`} className={props.class}>
                {props.Label}
            </Link>
            }
            {menuitem.Main_Parent != null && menuitem.Sub_Parent === null && props.link === menuitem.Primary_URL && menuitem.Main_Parent.Disable_Parent_URL != true &&
            <Link to={`/${menuitem.Main_Parent.Primary_URL}/${menuitem.Primary_URL}/`} className={props.class}>
                {props.Label}
            </Link>
            }
            {menuitem.Main_Parent != null && menuitem.Sub_Parent != null && props.link === menuitem.Primary_URL && menuitem.Main_Parent.Disable_Parent_URL == true &&
            <Link to={`/${menuitem.Sub_Parent.Primary_URL}/${menuitem.Primary_URL}/`} className={props.class}>
            {props.Label}
            </Link>
            }
            {menuitem.Main_Parent != null && menuitem.Sub_Parent != null && props.link === menuitem.Primary_URL && menuitem.Main_Parent.Disable_Parent_URL != true &&
            <Link to={`/${menuitem.Main_Parent.Primary_URL}/${menuitem.Sub_Parent.Primary_URL}/${menuitem.Primary_URL}/`} className={props.class}>
                {props.Label}
            </Link>
            }
        </>
        })}
    </>
  )
}
export default GetCTA;
